import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {useMemo} from 'react'

import {LABELS} from './constants/labels'
import type {MilestoneNode} from './repository-milestone-index-page-query-types'
import styles from './RepositoryMilestone.module.css'

// RELAY-CLEANUP(RepositoryMilestoneIndexPageContentInternal): widens nullable fields so the still-Relay parent
// data is assignable. Remove when RepositoryMilestoneIndexPageContentInternal leaves Relay.
export type MilestoneIssueCountFragment = RelayCompat<Pick<MilestoneNode, 'closedIssueCount' | 'openIssueCount'>>

type MilestoneIssueCountProps = {
  milestone: MilestoneIssueCountFragment
}

export function MilestoneIssueCount({milestone}: MilestoneIssueCountProps) {
  const issueCounts = useMemo(() => {
    const openIssueCount = milestone.openIssueCount ?? 0
    const closedIssueCount = milestone.closedIssueCount ?? 0
    return {
      open: openIssueCount,
      closed: closedIssueCount,
      total: openIssueCount + closedIssueCount,
    }
  }, [milestone.openIssueCount, milestone.closedIssueCount])

  if (issueCounts.total <= 0) {
    return null
  }

  return (
    <div className={styles.milestoneIssueCount}>
      <span className={styles.middot}>{LABELS.separator}</span>
      <span>
        {issueCounts.closed}/{issueCounts.total} issues closed
      </span>
    </div>
  )
}
